import { restoreNumber } from "./number"

export const isPositive = (val) => {
  val = restoreNumber(val)
  return !val || Number(val) > -1
}

export const transPositive = (val) => {
  if (!val) return val
  return val.replace('-', '')
}

